import React from 'react';
import Banner from '../../components/Banner';
import Navbar from '../../components/Navbar';
import OverviewHero from '../../components/investors/OverviewHero';
import OverviewMain from '../../components/investors/OverviewMain';

function Overview() {
    return (
        <div>
            <Banner />
            <Navbar />
            <OverviewHero />
            <OverviewMain />
        </div>
    )
}

export default Overview